import { fetchJson } from './fetcher'

export interface Dealership {
    id: number
    name: string
}

export async function getDealerships(): Promise<Dealership[]> {
    return fetchJson<Dealership[]>('v3/dealerships/')
}
